import { autoinject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';

export type ServiceQueueMoveOption = {
  targetId: string;
  targetKind: 'production' | 'queue';
  pipelineId: number;
  pipelineName: string;
  pipelineTypeName: string;
  label: string;
  order: number;
};

export type ServiceQueueMoveDialogParams = {
  options: ServiceQueueMoveOption[];
  selectedTargetId?: string;
};

@autoinject
export class ServiceQueueMoveDialog {
  private options: ServiceQueueMoveOption[] = [];
  private selectedTargetId: string | null = null;

  constructor(private dialogController: DialogController) {}

  activate(params: ServiceQueueMoveDialogParams) {
    this.options = params?.options || [];

    if (params?.selectedTargetId) {
      this.selectedTargetId = params.selectedTargetId;
    } else if (this.options.length > 0) {
      this.selectedTargetId = this.options[0].targetId;
    }
  }

  private confirm() {
    if (!this.selectedTargetId) {
      return;
    }

    this.dialogController.close(true, {
      targetId: this.selectedTargetId,
    });
  }

  private setSelectedTargetId(value: string) {
    this.selectedTargetId = value;
  }
}
